var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 13L13 1M1 1L13 13","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Close.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Close;

Close.default = Close;
